/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React from "react";

function useOutsideAlerter(ref: any, setX: any): void {

    React.useEffect(() => {
        function handleClickOutside(event: any) {
            if (ref.current && !ref.current.contains(event.target)) {
                setX(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref, setX]);
}

const AppDropdown = (props: {
    button: React.ReactNode;
    children: React.ReactNode;
    classNames: string;
    animation?: string;
}) => {
    const { button, children, classNames, animation } = props;
    const wrapperRef = React.useRef(null);
    const [openWrapper, setOpenWrapper] = React.useState(false);
    useOutsideAlerter(wrapperRef, setOpenWrapper);

    const onClickDropdown = () =>{
        setOpenWrapper(!openWrapper)
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    return (
        <div ref={wrapperRef} className="relative flex" >
            <div className="flex" onMouseDown={() => setOpenWrapper(!openWrapper)}>
                {button}
            </div>
            <div onClick={onClickDropdown}
                 className={`${classNames} absolute z-10 ${
                     animation
                         ? animation
                         : "origin-top-right transition-all duration-300 ease-in-out"
                 } ${openWrapper ? "scale-100" : "scale-0"}`}
            >
                {children}
            </div>
        </div>
    );
};

export default AppDropdown;
